import React from 'react';
import FormControl from "@mui/material/FormControl";
import {InputLabel, Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {Trans, useTranslation} from "react-i18next";
import Typography from "@mui/material/Typography";

function DropDownParam({id, values, onChange, value, forCart, props}) {
    const {t} = useTranslation();

    const handleChange = (event) => {
        const itemKey = event.target.value;
        const selectedVal = values.filter(val => val.label === itemKey)[0];

        if (selectedVal) {
            onChange(id, selectedVal);
        } else {
            onChange(id, values[0]);
        }
    }

    return (forCart ?
            <Typography sx={{color: 'text.secondary'}} variant={'body2'}>
                <Trans i18nKey={`params.${id}`}/>: {value?.translate ? <Trans i18nKey={value?.label}/> : value?.label}
            </Typography> :
            <FormControl fullWidth>
                <InputLabel id={`${id}-label`}><Trans i18nKey={`params.${id}`}/></InputLabel>
                <Select
                    labelId={`${id}-label`}
                    id={id}
                    value={value?.label}
                    label={t(`params.${id}`)}
                    sx={{height: 40}}
                    onChange={handleChange}
                >
                    {values.map(val => <MenuItem key={val?.label} value={val?.label}>{val?.translate ?
                        <Trans i18nKey={val?.label}/> : val?.label}</MenuItem>)}
                </Select>
            </FormControl>
    );
}

export default DropDownParam;
